import { Instagram, Linkedin, Twitter, ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-white" data-testid="rgu-footer">
      <div className="rgu-container py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="rgu-eyebrow text-amber-300 mb-4">Real Game Used LLC.</div>
            <h3 className="font-display text-3xl md:text-4xl leading-tight">
              The research standard for game &amp; event used memorabilia.
            </h3>
            <p className="mt-6 text-slate-300 max-w-md leading-relaxed">
              30+ years of expertise. Over $35,000,000 authenticated. 2,500+ Letters of Authenticity issued.
              Photo Match &amp; Traditional Authentication for Sports, Music, Film and Entertainment.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="rgu-eyebrow text-slate-400 mb-4">Connect</div>
            <ul className="space-y-3">
              <li>
                <a href="https://www.instagram.com/realgameused/" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-amber-300" data-testid="social-instagram">
                  <Instagram className="w-4 h-4" /> Instagram
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/marshall-perkins-iii-42875648" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-amber-300" data-testid="social-linkedin">
                  <Linkedin className="w-4 h-4" /> LinkedIn
                </a>
              </li>
              <li>
                <a href="https://www.x.com/realgameused" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-amber-300" data-testid="social-x">
                  <Twitter className="w-4 h-4" /> X / Twitter
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="rgu-eyebrow text-slate-400 mb-4">Contact</div>
            <p className="text-slate-300 leading-relaxed">
              <a href="mailto:info@realgameused.com" className="underline hover:text-amber-300" data-testid="footer-email">info@realgameused.com</a><br/>
              RGU — 530 E. Hunt Highway,<br/>
              Suite 103-225, AZ 85143
            </p>
            <a
              href="https://infiniteauctions.com/consign"
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 bg-amber-400 text-[#0A192F] px-5 py-3 font-medium hover:bg-amber-300"
              data-testid="footer-consign-link"
            >
              Consign to Auction <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-700 flex flex-col md:flex-row md:items-center md:justify-between text-xs text-slate-400 font-mono-rgu uppercase tracking-widest">
          <div>© {new Date().getFullYear()} Real Game Used — All Rights Reserved</div>
          <div className="mt-3 md:mt-0">A subsidiary of Medical Care Technologies Inc. (OTC: MDCE)</div>
        </div>
      </div>
    </footer>
  );
}
